<!-- 
  @file VehicleDetails.vue
  @description
  A component that displays detailed information about a vehicle.

  @props
  - vehicle: {
      vrm: string | null;              // Vehicle registration mark
      registrationYear: string | null;  // Year of registration
      make: string | null;             // Vehicle manufacturer
      model: string | null;            // Vehicle model
      price: number | null;            // Vehicle price
      colour: string | null;           // Vehicle color
      mileage: number | null;          // Vehicle mileage
      transmission: string | null;      // Transmission type
      fuelType: string | null;         // Fuel type
      imageUrl: string | null;         // URL to vehicle image
      dealerInfoUrl: string | null;    // URL to dealer information
      trim: string | null;             // Vehicle trim level
    }
  - showVehicleImage?: boolean         // Controls visibility of vehicle image (default: true)
  - showVehicleSpecs?: boolean         // Controls visibility of vehicle specs (default: true)
  - showVehicleCardBorder?: boolean   // Controls visibility of vehicle card border (default: true)

  @features
  - Displays comprehensive vehicle information
  - Optional vehicle image display
  - Responsive layout
  - Theme-aware styling
-->

<template>
  <VehicleCard
    :id="uniqueId"
    :registration-year="vehicle?.registrationYear"
    :make="vehicle?.make"
    :model="vehicle?.model"
    :price="vehicle?.price"
    :colour="vehicle?.colour"
    :mileage="vehicle?.mileage"
    :transmission="vehicle?.transmission"
    :fuel-type="vehicle?.fuelType"
    :image-url="vehicle?.imageUrl"
    :vrm="vehicle?.vrm"
    :dealer-info-url="vehicle?.dealerInfoUrl"
    :trim="vehicle?.trim"
    :listItemBackgroundColor="'hsl(var(--twc-usp)'"
    :listItemTextColor="'text-dark-1'"
    :show-vehicle-image="showVehicleImage"
    :show-vehicle-specs="showVehicleSpecs"
    :show-vehicle-card-border="showVehicleCardBorder"
    :vehicle-id="vehicle?.vehicleId"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

const { showVehicleImage = true, showVehicleSpecs = true, showVehicleCardBorder = true, vehicle } = defineProps<{
  showVehicleImage?: boolean;
  showVehicleSpecs?: boolean;
  showVehicleCardBorder?: boolean;
  vehicle: {
    vrm: string | null;
    registrationYear: string | null;
    make: string | null;
    model: string | null;
    price: number | null;
    colour: string | null;
    mileage: number | null;
    transmission: string | null;
    fuelType: string | null;
    imageUrl: string | null;
    dealerInfoUrl: string | null;
    trim: string | null;
    vehicleId: number | null;
  };
}>();

const uniqueId = computed(() => `${vehicle.vrm}-${Date.now()}`);
</script> 